var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row layer-featureable-gallery" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm.textHeader
          ? [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 d-flex align-items-center" }, [
                  _vm.iconHeader
                    ? _c("i", { staticClass: "mr-2", class: _vm.iconHeader })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.textHeader)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "mt-0" }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 px-0" },
            _vm._l(_vm.groups, function (group, index) {
              return _c("LayerFeatureableGroup", {
                key: `layer-featureable-group-${index}`,
                attrs: {
                  cardGroupClass: _vm.cardGroupClass,
                  entity: group.entity,
                  items: group.features,
                  translateID: _vm.translateID,
                },
                on: { selected: _vm.onSelected },
              })
            }),
            1
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }